import Select2VM, { Select2VMConfig } from 'components/select2/select2';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Observable, ObservableArray, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { withEffect } from 'mixins/withEffect';
import { EffectsContainer } from 'mixins/withEffects';
import { DataFormat } from 'select2';
import './picker.html';
import './picker.scss';

components.preload('wcc-select-2');

export interface ThreadEditorPickerVMConfig {
    data: SubscribableOrNullableValue<Array<DataFormat>>

    isMultiple: SubscribableOrNullableValue<boolean>
    isLoading: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class ThreadEditorPickerVM {
    selectConfig: Select2VMConfig
    select: Observable<Select2VM | undefined> = ko.observable()

    isLoading: Subscribable<boolean>
    hasData: Subscribable<boolean>

    selection: ObservableArray<string> = ko.observableArray()

    constructor(
        @inject(wccModules.componentConfig) config: ThreadEditorPickerVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        const data = ko.flattenComputed(config.data, []);
        const isMultiple = ko.flattenComputed(config.isMultiple, false);

        this.isLoading = ko.flattenComputed(config.isLoading, false);
        this.hasData = ko.pureComputed(() => data().length > 0);

        this.selectConfig = {
            multiple: isMultiple,
            data: data
        }

        effects.register(select => {
            if (select != undefined) {
                return [
                    withEffect(selection => {
                        if (!system.isTheSameList(selection, select.selection()))
                            select.selection(_.clone(selection));
                    }, [this.selection]),

                    withEffect(selectSelection => {
                        if (!system.isTheSameList(selectSelection, this.selection()))
                            this.selection(_.clone(select.selection()));
                    }, [select.selection])
                ]
            }
        }, [this.select]);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'thread-editor-picker': true
            }
        }, this);
    }
}